import * as Sentry from '@sentry/react';

/**
 * Manually capture exception to Sentry
 * @param {Error} error
 * @param {Object} [context] - optional context details to attach as extra tags/metadata
 */
export const captureException = (error, context = {}) => {
    try {
        console.error('Sentry captured error:', error, context);
        Sentry.withScope((scope) => {
            if (context && Object.keys(context).length > 0) {
                Object.entries(context).forEach(([key, value]) => {
                    scope.setExtra(key, value);
                });
            }
            Sentry.captureException(error);
        });
    } catch (error) {
        console.log('captureException', error)
    }
};

/**
 * Manually capture a message to Sentry
 * @param {string} message
 * @param {string} [level] - 'info', 'warning', 'error', etc.
 * @param {Object} [context] - optional context details
 */
export const captureMessage = (message, level = 'info', context = {}) => {
    try {
        console.log(`Sentry captured message (${level}):`, message, context);
        Sentry.withScope((scope) => {
            scope.setLevel(level);
            if (context && Object.keys(context).length > 0) {
                Object.entries(context).forEach(([key, value]) => {
                    scope.setExtra(key, value);
                });
            }
            Sentry.captureMessage(message);
        });
    } catch (error) {
        console.log('captureMessage', error)
    }
};
